import React from "react";
import { Share2, ExternalLink } from "lucide-react";
import Iterator from "../utils/Iterator";
import { useTranslation } from "react-i18next";
import { socialMediaTypes } from "../../enum/socialMediaType";
import { SettingsSocialMedia } from "../../Models/SettingsModel";

function SocialMedia(props: { social: SettingsSocialMedia[] }) {
  const { t } = useTranslation();
  
  const renderSocialMedia = (e: SettingsSocialMedia, i: number) => {
    let url = e.link;
    if (!url.startsWith("https://") && !url.startsWith("http://")) {
      url = "https://" + url;
    }

    return (
      <a
        key={e.id || i}
        href={url}
        target="_blank"
        rel="noreferrer"
        className="flex items-center gap-2.5 p-2.5 rounded-lg bg-muted/40 border border-border/40 hover:border-primary/30 hover:bg-muted/60 transition-all duration-200 group"
      >
        <div className="flex-shrink-0 p-1.5 rounded-md bg-primary/10 group-hover:bg-primary/20 transition-colors">
          <div className="text-primary text-base">
            {socialMediaTypes[e.type]}
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-foreground group-hover:text-primary transition-colors break-words">
            {e.title}
          </p>
        </div>
        <ExternalLink className="w-3.5 h-3.5 text-muted-foreground group-hover:text-primary transition-colors flex-shrink-0" />
      </a>
    );
  };

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-2 pb-2 border-b border-primary/20">
        <div className="p-1 rounded-md bg-primary/10 border border-primary/20">
          <Share2 className="w-4 h-4 text-primary" />
        </div>
        <h3 className="text-base font-bold text-foreground">
          {t("gloabl.connectUs")}
        </h3>
      </div>
      <div className="flex flex-col gap-2">
        <Iterator data={props.social} render={renderSocialMedia} />
      </div>
    </div>
  );
}

export default SocialMedia;
